import React from "react";
import { typeForm } from "../../../../types/forms";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, InputNumber, Row } from "antd";
import { useFieldsHrsEquivalency } from "../hooks/useFieldsHrsEquivalency";
import { MexicoFlag, USAFlag } from "../../../../components/icons";


export const FormSimulationEquivalency = ({ type = typeForm.create, updateProject }) => {
    const dispath = useDispatch();
    const {
        simulation: { formEquivalecy },
    } = useSelector((state) => state);

    const { form, onFinish } = useFieldsHrsEquivalency(dispath, { formCheckState: formEquivalecy }, type);
    return (
        <Form form={form} onFinish={(props) => {
            onFinish(props, updateProject);
        }} name="platform_project" layout="vertical" className="w-full">
            <div className="grid gap-4 grid-cols-2">
                <Form.Item
                    name={["assetMoneyDLL"]}
                    label={
                        <span>
                            <span>Horas de assets en DLL</span> <USAFlag className="inline mb-1" />
                        </span>
                    }
                    rules={[
                        {
                            type: "number",
                            min: 1,
                            message: "El numero no tiene que ser cero",
                        },
                        {
                            required: true,
                            message: "Necesita mayor a cero",
                        },
                    ]}
                >
                    <InputNumber size="large" min={0} className="w-full" />
                </Form.Item>
                <Form.Item
                    name={["assetMoneyMX"]}
                    label={
                        <span>
                            <span>Horas de assets en MX</span> <MexicoFlag className="inline mb-1" />
                        </span>
                    }
                    rules={[
                        {
                            type: "number",
                            min: 1,
                            message: "El numero no tiene que ser cero",
                        },
                        {
                            required: true,
                            message: "Necesita mayor a cero",
                        },
                    ]}
                >
                    <InputNumber size="large" min={0} className="w-full" />
                </Form.Item>
                <Form.Item
                    name={["providerMoneyMX"]}
                    label={
                        <span>
                            <span>Hrs de proveedor en DLL</span> <USAFlag className="inline mb-1" />
                        </span>
                    }
                    rules={[
                        {
                            type: "number",
                            min: 1,
                            message: "El numero no tiene que ser cero",
                        },
                        {
                            required: true,
                            message: "Necesita mayor a cero",
                        },
                    ]}
                >
                    <InputNumber size="large" min={0} className="w-full" />
                </Form.Item>
                <Form.Item
                    name={["providerMoneyDLL"]}
                    label={
                        <span>
                            <span>Hrs de proveedor en MX</span> <MexicoFlag className="inline mb-1" />
                        </span>
                    }
                    rules={[
                        {
                            type: "number",
                            min: 1,
                            message: "El numero no tiene que ser cero",
                        },
                        {
                            required: true,
                            message: "Necesita mayor a cero",
                        },
                    ]}
                >
                    <InputNumber size="large" min={0} className="w-full" />
                </Form.Item>
            </div>
            <Row justify="end" gutter={[16, 0]}>
                <Col>
                    <Form.Item className="w-full flex justify-end m-0 mt-4">
                        <Button type="primary" htmlType="submit" className="bg-primaryTwo hover:bg-primaryTwoHover">
                            {type === typeForm.create ? "Crear" : "Editar"}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};
